<div [class]="class" [formGroup]="form">
  <mat-button-toggle-group [formControlName]="name" aria-label="Toggle group" [vertical]="vertical">
    <div class="flex gap-1" [ngClass]="{ 'flex-column': vertical }">
      @for (option of options; track option.value;) {
        <mat-slide-toggle [checked]="form.get(name)?.value?.includes(option.value)" (change)="toggleOption(option.value)" color="primary">
          <!-- {{option.label}} -->
          <div class="flex align-items-center gap-1" [innerHTML]="option.label | appSafeHtml"></div>
        </mat-slide-toggle>
      }
    </div>
  </mat-button-toggle-group>
  <mat-error *ngIf="hasError()" class="text-xs">{{error()}}</mat-error>
  <mat-hint *ngIf="hint" class="text-xs text-600">{{hint}}</mat-hint>
</div>
